import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStarzComponent } from './simple-icons-starz.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStarzComponent ],
    exports:      [ SimpleIconsStarzComponent ],
    bootstrap:    []
})
export class SimpleIconsStarzModule {}
